import { useEffect } from "react";
import "./LogoutSuccess.css";
import { useNavigate } from "react-router-dom";

// Access the dashboard URL from environment variables
const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;

/**
 * LogoutSuccess Component
 *
 * This component serves as a logout confirmation screen.
 * It clears session and local storage, then redirects the user
 * to the GTM Factory Dashboard after a 5-second delay.
 */
const LogoutSuccess = () => {
  const navigate = useNavigate(); // Reserved for internal navigation if needed later

  useEffect(() => {
    // Set a timer to perform cleanup and redirection after 5 seconds
    const timer = setTimeout(() => {
      // Clear all session and local storage data
      sessionStorage.clear();
      localStorage.clear();

      // Redirect to the GTM Factory Dashboard using env variable
      window.location.href = process.env.REACT_APP_DASHBOARD_URL;
    }, 5000);

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="logout-container">
      <div className="logout-text">
        <h2>You have been logged out of the application</h2>
        <p>
          You will be redirected to the GTM Factory Dashboard shortly, or{" "}
          {/* Fallback link for immediate redirection */}
          <a className="login-link" href={DASHBOARD_URL}>
            click here
          </a>{" "}
          if not redirected.
        </p>
      </div>
    </div>
  );
};

export default LogoutSuccess;
